import { styled } from '@mui/material/styles';

export const StyledRadioControlIcon = styled('span')(({ theme }) => ({
  boxSizing: 'border-box',
  borderRadius: '50%',
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.neutral[200]}`,
  'input:disabled ~ &': {
    backgroundColor: theme.palette.neutral[100],
    borderColor: theme.palette.neutral[200],
  },
}));

export const StyledRadioControlCheckedIcon = styled(StyledRadioControlIcon)(
  ({ theme }) => ({
    border: `6px solid ${theme.palette.brandSecondary.mainCustom}`,
    'input:disabled ~ &': {
      backgroundColor: theme.palette.neutral[0],
      border: `7px solid ${theme.palette.neutral[200]}`,
    },
  }),
);
